import { scrollToElement } from 'lib/userFunctions';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Loading } from 'app/components/Loading';
import ErrorMessageBox from 'app/components/ErrorMessageBox';
import { useParams } from 'react-router-dom';

import { POLICY_TYPE_NAME } from 'lib/const';
import { PolicyList } from './PolicyList';
import { useQuery } from "@tanstack/react-query";
import Api, { createFetchErrorMessage } from 'utils/api/Api';

export const Policy = ()=>{
    const { type } = useParams();
    const config = useSelector(state => state.config);
    const [policyId, setPolicyId] = useState(0);
    
    useEffect(() => scrollToElement(), [type]);

    const { data:policy, isLoading, isError, error} = useQuery({
        queryKey:['policy', type],
        queryFn:()=>Api.get(`/api/policy/${type}/${policyId || 0}`),
        staleTime:1000 * 60 * 60,
        gcTime:1000 * 60 * 60,
    });

    
    const policyContent = useMemo(() => {
        if(isLoading) return <Loading />;
        if(isError) return < ErrorMessageBox message={createFetchErrorMessage(error).message} />;
        if(policy.data===null)return null;
        return (
            <div className="inner">
                <h3><span>{POLICY_TYPE_NAME[policy.data?.type]}</span></h3>
                <div dangerouslySetInnerHTML={{__html:policy.data?.content?.replaceAll('$serviceName', config.serviceName)}}></div>;
            </div>
        );
    }, [config.serviceName, error, isError, isLoading, policy]);

    return (
        <div className="subpage">
            <div id="contents" className={`member policy privacy ${type}`}>
                <div className="section">
                    {policyContent}
                </div>
                <PolicyList activeId={policyId} onChange={(id)=>setPolicyId(id)} />
            </div>
        </div>
    );
}